<div class="context-view" cf>
  @if (driverId() !== null) {
    <div class="context-header">
      <div class="context-title">{{ 'MASTERDATA.DRIVER.CONTEXT.EDIT' | translate }} {{ driverId() }}</div>
      <div class="f-1"></div>
      <div class="context-corner">
        <dx-button class="small-button" icon="close" (onClick)="close()"></dx-button>
      </div>
    </div>
  } @else {
    <div class="context-header">
      <div class="context-title">{{ 'MASTERDATA.DRIVER.CONTEXT.CREATE' | translate }}</div>
      <div class="f-1"></div>
      <div class="context-corner">
        <dx-button class="small-button" icon="close" (onClick)="close()"></dx-button>
      </div>
    </div>
  }
  @if (!isLoading()) {
    <form>
      <dx-form
        id="form"
        class="form last plain-styled-form"
        [formData]="formData"
        labelMode="floating"
        [(isDirty)]="isDirty">
        <dxi-item itemType="group" [colCount]="2">
          <dxi-item
            dataField="employeeNumber"
            editorType="dxTextBox"
            [visible]="type === 'edit'"
            [isRequired]="type === 'edit'"
            [editorOptions]="{ readOnly: true }">
            <dxo-label [text]="'MASTERDATA.DRIVER.DTO.ID' | translate"> </dxo-label>
          </dxi-item>
          <dxi-item
            dataField="firstName"
            editorType="dxTextBox"
            [isRequired]="true"
            [editorOptions]="{ readOnly: true }">
            <dxo-label [text]="'MASTERDATA.DRIVER.DTO.VORNAME' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colCount]="2">
          <dxi-item
            dataField="lastName"
            editorType="dxTextBox"
            [isRequired]="true"
            [editorOptions]="{ readOnly: true }">
            <dxo-label [text]="'MASTERDATA.DRIVER.DTO.NACHNAME' | translate"> </dxo-label>
          </dxi-item>
          <dxi-item
            dataField="drivingLicence"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: licenseTypes, displayExpr: 'display', valueExpr: 'value', readOnly: true }"
            [isRequired]="true">
            <dxo-label [text]="'MASTERDATA.DRIVER.DTO.LICENSENUMBER' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colCount]="2">
          <dxi-item
            dataField="priority"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: priorityLevels, displayExpr: 'display', valueExpr: 'value' }"
            [isRequired]="true">
            <dxo-label [text]="'MASTERDATA.DRIVER.DTO.PRIO' | translate"> </dxo-label>
          </dxi-item>
          <dxi-item
            dataField="identifier"
            editorType="dxTextBox"
            [isRequired]="true"
            [editorOptions]="{ readOnly: true }">
            <dxo-label [text]="'MASTERDATA.DRIVER.DTO.KURZZEICHEN' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </form>
    <div class="container">
      <dx-button class="submit-button" (onClick)="save()" [disabled]="!isDirty" [text]="'SHARED.SAVE' | translate">
      </dx-button>
    </div>
  } @else {
    <app-loader></app-loader>
  }
</div>
